import { render, staticRenderFns } from "./OfficeInsuranceProposalList.vue?vue&type=template&id=70e20654"
import script from "./OfficeInsuranceProposalList.vue?vue&type=script&lang=js"
export * from "./OfficeInsuranceProposalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports